import { isBoolean, observable } from '@legendapp/state'
import { ObservablePersistLocalStorage } from '@legendapp/state/persist-plugins/local-storage'
import { syncObservable } from '@legendapp/state/sync'
import { createContext, FC, PropsWithChildren, useContext } from 'react'

interface State$ {
  isSidebarOpen: boolean
  toggleSidebar: (state?: boolean | null | undefined) => void
}

interface LayoutContext {
  state$: typeof state$
}

const state$ = observable<State$>({
  isSidebarOpen: true,
  toggleSidebar: (state) => {
    if (isBoolean(state)) {
      state$.isSidebarOpen.set(state!)

      return
    }

    state$.isSidebarOpen.toggle()
  },
})

syncObservable(state$, {
  persist: {
    name: 'consoleLayout',
    plugin: ObservablePersistLocalStorage,
  },
})

const ConsoleLayoutContext = createContext<LayoutContext | null>(null)

export const Provider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConsoleLayoutContext.Provider value={
      {
        state$,
      }
    }
    >
      {children}
    </ConsoleLayoutContext.Provider>
  )
}

export const useLayoutContext = () => {
  const context = useContext(ConsoleLayoutContext)

  if (context === null) {
    throw new Error(`ContextLayout.useLayoutContext must be used within ContextLayout.Provider`)
  }

  return context
}
